import { Component } from '@angular/core';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as $ from 'jquery';

@Component({
  selector: 'app-bom-process',
  templateUrl: './bom-process.component.html',
  styleUrls: ['./bom-process.component.css']
})
export class BomProcessComponent {
  processFlowObj = {preLoading: false, bomTable: false, bomCustomUpload: false, bomColumnScreen: false,pregeneratedLength: '', customLength: '',customBomUploadMsg: false,bomTableMsg: false};
  headerCheck = false;
  showLineItemEdit = false;
  selectedBomObj: any;
  lineItemEdit :any = 'Edit';
  editLineItemForm:any= FormGroup;
  bomDataItems: any = {};
  countDniCheck = 0;
  sqsgenerationcount = 0.0;
  uploadedFile: any = {};
  autoMappingData:any;
  uploadedNewBomName:any;
  showNumberOfSheets : boolean = false;
  selectedSheetNum:any;
  lostBomItemIndex:any;
  mainRowArrayObj:any = {
    'labelsArray' : [],
    'bomOneMapArrayData' : []
  };
  pageShow : any = {
    "showLevel1BomItemsData" : true,
    "showerrorFreeBomItemsData" : false
  }
  sheetsArray :any =[];
  showNoDataMsg = "Please upload a BOM to proceed";
  disableAutomapProceed : boolean = false;
  uploadButtonDisabled: boolean = false;
  closeResult: string = '';
  showSaveItemEditOpt = false;
  buttonsDisabled = true;
  bomId:any;
  itemsLength:any;
  fixedLineItemsArray:any=[];
  currentDateTime:any;
  mappingDateTime:any;
  mappingArray:any=[];
  selectedColMapValList:any=[];
  mapValueArray:any=[];
  bomMappingKeyObj:any={};
  flowActivityId:any='';

  constructor(private modalService: NgbModal,
    public apiService : ApiService,
    public commonService : CommonEventService,
    private router: Router,
    public formBuilder : FormBuilder){

  }

  // form validation of edit line item
  edit_line_validation_messages = {
    'item_num': [
      { type: 'required', message: 'Item Number is required.' },
      { type: 'minlength', message: 'Item Number must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Item Number cannot be more than 100 characters long.' }
    ],
    'quantity': [
      { type: 'required', message: 'Quantity is required.' },
      { type: 'minlength', message: 'Quantity must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Quantity cannot be more than 100 characters long.' }
    ],
    'ref_designators': [
      { type: 'required', message: 'Ref. Designators is required.' },
      { type: 'minlength', message: 'Ref. Designators must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Ref. Designators cannot be more than 100 characters long.' }
    ],
    'mpn': [
      { type: 'required', message: 'MPN is required.' },
      { type: 'minlength', message: 'MPN must be at least 1 characters long.' }
    ]
  }

  ngOnInit(){
    this.commonService.sessionPortalLoad();
    window.scrollTo(0, 0);
    this.commonService.formattingCurrentDateTime();
    var bomProcessInitData={
      "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    this.apiService.updateDetailsToDashboard(this.flowActivityId,bomProcessInitData,'BOMPreProcessorPage').subscribe((resDatas)=>{
    },err=>{
      console.log(err)
    });
    this.saveBOMFn(true);
    this.commonService.restrictBrowserButtons();
    this.commonService.restrictRefreshButton();
  }
  
  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }
  
  saveBOMFn(init:any){
    if(init){
      this.commonService.loadingShow();
    }
    this.apiService.getBOMData(this.commonService.commonMainObj.bomProcessData).subscribe((getBomDataRes) =>{
      if(this.commonService.commonMainObj.userSessionMemberId != null){
        this.commonService.sessionPortalLoad();
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.commonService.loadingHide();
              this.commonService.commonMainObj.bomProcessXlData = getBomDataRes
              this.getBOMTableData('pregenerated');
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      }else{
        this.commonService.loadingHide();
        this.commonService.commonMainObj.bomProcessXlData = getBomDataRes
        this.getBOMTableData('pregenerated');
      }
    })
  }

  uploadFiles(content:any,logs: any){
    // console.log("UPLOADED FILE DATA",logs.target.files);
    // this.callUploadFilesLogic(content,logs);
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
    }
    if(this.commonService.commonMainObj.autoUploadFileName){
      this.autoBomReplaceAlert(content,logs);
    }else{
      $('#customFileUpload').trigger('click');
      this.callUploadFilesLogic(content,logs);
    }
  }
  autoBomReplaceAlert(content:any,logs: any){
    this.commonService.bomConfirmAlert('The existing BOM in the initial files will be replaced with the new BOM. Are you sure you want to proceed with uploading a different BOM?').then((result:any) => {
      if (result.isConfirmed) {
        $('#customFileUpload').trigger('click');
        this.callUploadFilesLogic(content,logs);
      } else if (result.isDismissed) {
        return false;
      }
    })
  }
  callUploadFilesLogic(content:any,logs: any){
    this.commonService.commonMainObj.uploadedFile = logs.target.files[0];
    this.uploadedNewBomName = this.commonService.commonMainObj.uploadedFile.name;
    let fileExtension = this.uploadedNewBomName.split('.').pop()?.toLowerCase();
    // console.log("this.uploadedNewBomName",this.uploadedNewBomName);
    // console.log("fileExtension",fileExtension);
    let allowedExtension = ['xls','xlsx'];
    if(fileExtension && allowedExtension.includes(fileExtension)){
      this.commonService.commonMainObj.uploadedFileFullPath = logs.target.value;
      this.commonService.commonMainObj.autoUploadFileName = '';
      this.commonService.commonMainObj.manuallyBomUploded = true;
      this.bomProceed(content);
      //Below code is for manually uploded file converting into blod data to attach uploded file to zip
      const file = logs.target.files[0];
      const reader = new FileReader();
      var convertedFile :any = [];
      reader.readAsDataURL(file);
      reader.onload = () => {
          // console.log("FILE TO BASE64",reader.result);
        convertedFile = reader.result;
      };
      setTimeout(() => {
        if(convertedFile){
          this.commonService.commonMainObj.bomToBloobFile = convertedFile.toString().split('base64,')[1]
          //console.log("Converted Data", this.commonService.commonMainObj.bomToBloobFile);
        }
      }, 100);
    }else{
      this.commonService.alertCall('Alert!!','Please upload file in .xls or .xlsx format only');
      return;
    }
    $("#customFileUpload").val('');
  }

  bomProceed(content:any){
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            this.bomProceedSessionChecked(content);
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      },800);
    }else{
      this.bomProceedSessionChecked(content);
    }
  }

  bomProceedSessionChecked(content:any){
    this.selectedSheetNum = '';
    this.commonService.commonMainObj.customS3BomId='';
    this.commonService.commonMainObj.bomFileData = this.commonService.commonMainObj.uploadedFile;
    this.apiService.assemblyBomSheetsProcees(this.commonService.commonMainObj.uploadedFile).subscribe((sheetsData:any) => {
        this.sheetsArray = [];
        this.showNumberOfSheets = true;
        console.log("sheetsData",sheetsData);
        this.commonService.commonMainObj.customS3BomId = sheetsData[0].uploadedFileName;
        var newBomUplodedObj = {
          "bomName":this.uploadedNewBomName+'|'+this.commonService.commonMainObj.customS3BomId,
          "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime,
          "bomReUploaded":'Yes'
        } 
        this.apiService.updateDetailsToDashboard(this.flowActivityId,newBomUplodedObj,'BOMPreProcessorPage').subscribe((resDatas:any)=>{   
          this.commonService.commonMainObj.backToPrevPageActivityId  = resDatas.activityId; 
        },err=>{
          console.log(err)
          });
        for(var sheetIndx in sheetsData){
          this.sheetsArray.push(sheetsData[sheetIndx])
        }
        if(this.sheetsArray.length == 1){
          // this.showNumberOfSheets = true;
          this.selectedSheetNum = '0';
          this.bomFinalMapData('')
          this.autoMapModal(content);
          setTimeout(()=>{        
            this.commonService.loadingHide();
          },1000);
        }else{
          this.showNumberOfSheets = false;
          this.autoMapModal(content);       
          this.commonService.loadingHide();
        }
    },error => {
      this.commonService.loadingHide();
      console.log(error);
    })
    // this.bomFinalMapData(bomFile,content)
  }

  proceedSheet(){
    if(this.selectedSheetNum){
      this.bomFinalMapData('')
    }else{
      this.commonService.alertCall('Warning!','Please select sheet');
    }
  }

  bomFinalMapData(content:any){
    // this.commonService.loadingShow();
    var bomFile = this.commonService.commonMainObj.uploadedFile;
    this.apiService.assemblyBomProcees(bomFile,this.selectedSheetNum).subscribe((data:any) => {
      this.commonService.loadingHide();
      this.autoMappingData = '';
      this.mainRowArrayObj = {
        'labelsArray' : [],
        'bomOneMapArrayData' : []
      };
      data['columnheaderMapIndex']['item_num']= data['columnheaderMapIndex']['item_num'] || data['columnheaderMapIndex']['item_num'] == 0?data['columnheaderMapIndex']['item_num']:null;
      data['columnheaderMapIndex']['manufacturer_part_number']= data['columnheaderMapIndex']['manufacturer_part_number'] || data['columnheaderMapIndex']['manufacturer_part_number'] == 0?data['columnheaderMapIndex']['manufacturer_part_number']:null;
      data['columnheaderMapIndex']['reference_designators']= data['columnheaderMapIndex']['reference_designators'] || data['columnheaderMapIndex']['reference_designators'] == 0?data['columnheaderMapIndex']['reference_designators']:null;
      data['columnheaderMapIndex']['quantity']= data['columnheaderMapIndex']['quantity'] || data['columnheaderMapIndex']['quantity'] == 0?data['columnheaderMapIndex']['quantity']:null;
      this.autoMappingData = data;
      this.commonService.commonMainObj.autoMappingHeaderData = this.autoMappingData['rowHeaderBOMData'];
      this.commonService.commonMainObj.bomProcessXlData = '';
      this.commonService.commonMainObj.bomProcessXlData = data;
      for(let dataIndex in this.autoMappingData['columnheaderMapIndex']){
        var displayName = dataIndex == 'item_num'?'Item Number':dataIndex == 'quantity'?'Quantity':dataIndex == 'reference_designators'?'Reference designator': dataIndex == 'manufacturer_part_number'?'MPN': dataIndex == 'manufacturer'?'Manufacturer':dataIndex == 'description'?'Description':dataIndex == 'value' ? 'Value':dataIndex == 'do-not-install'?'DNI':dataIndex == 'vendor_part_number'?'VPN':dataIndex == 'footprint'?'Footprint':dataIndex;
        var labelObj = {
          'labelName' : displayName,
          'labelType':'existing',
          'selectedName1' : this.autoMappingData['columnheaderMapIndex'][dataIndex] != null ?parseInt(this.autoMappingData['columnheaderMapIndex'][dataIndex]):'',
          'mainlabelData': this.autoMappingData['columnheaderMapIndex'][dataIndex] != null ?parseInt(this.autoMappingData['columnheaderMapIndex'][dataIndex]):'',
          'mainLabelName': dataIndex
        }
        this.mainRowArrayObj['labelsArray'].push(labelObj);
        if(dataIndex == 'manufacturer_part_number'){
          this.commonService.commonMainObj.mpnIndex = this.autoMappingData['columnheaderMapIndex'].manufacturer_part_number;
        }
        if(dataIndex == 'quantity'){
          this.commonService.commonMainObj.qtyIndex = this.autoMappingData['columnheaderMapIndex'].quantity;
        }
        if(dataIndex == 'reference_designators'){
          this.commonService.commonMainObj.refDesignatorIndex = this.autoMappingData['columnheaderMapIndex'].reference_designators;
        }
        if(dataIndex == 'vendor_part_number'){
          this.commonService.commonMainObj.partNumberIndex = this.autoMappingData['columnheaderMapIndex'].vendor_part_number;
        }
        if(dataIndex == 'manufacturer'){
          this.commonService.commonMainObj.maufacturerIndex = this.autoMappingData['columnheaderMapIndex'].manufacturer;
        }
      }
      for(var bomDataIndex in this.autoMappingData['rowHeaderBOMData']){
        var dropDownDataObj = {
          'labelValue' : this.autoMappingData['rowHeaderBOMData'][bomDataIndex],
          'labelIndx' : bomDataIndex,
          'selectedObj' : bomDataIndex
        }
        this.mainRowArrayObj['bomOneMapArrayData'].push(dropDownDataObj);
      }
      this.showNumberOfSheets = true;
      setTimeout(() => {
        this.checkIfAllOptionsPresent();
      }, 500);
      // this.autoMapModal(content);
    },error => {
      if(error.status == 400){
        this.commonService.showtoast(error.error.error,'warning');
      }
      this.commonService.loadingHide();
      console.log(error);
    })
  }

  checkIfAllOptionsPresent(){
    var allValuesSelected = true;
    // if($('#columnMap_1').val() == '' || $('#columnMap_2').val() == '' || $('#columnMap_3').val() == '' || $('#columnMap_4').val() == ''){
    //   allValuesSelected = false;
    //   return false;
    // }
    $('.header-mapping-dropdown').each(function() {
      //Changes done based on OFP-652
      // if (!$(this).val()) {
      if (!$(this).val() && $(this).hasClass('requiredField')) {
        allValuesSelected = false;
        return false;
      }
    });
    if (allValuesSelected) {
      this.disableAutomapProceed = false;
    }else{
      this.disableAutomapProceed = true;
    }
  }

  proceedAutoMapData(){
    if(this.disableAutomapProceed == true){
      this.commonService.showtoast('Please map all mandatory columns to proceed','warning');
      return false;
    }else{ 
      setTimeout(()=>{
        this.commonService.commonMainObj.bomProcessData['bom_id'] = '';
        this.commonService.commonMainObj.bomProcessData['user_id'] = this.commonService.commonMainObj.userData.userId?this.commonService.commonMainObj.userData.userId:null;
        this.commonService.commonMainObj.bomProcessData['project_id'] = this.commonService.commonMainObj.fileUploadedData['projectId'];
        this.commonService.commonMainObj.bomProcessData['row_mapping'] = {
          "header": this.commonService.commonMainObj.bomProcessXlData['headerRowNumber'],
          "data": this.commonService.commonMainObj.bomProcessXlData['dataRowNumber'],
          "lines": this.commonService.commonMainObj.bomProcessXlData['numberOfDataLineItems']
        };
        var labelsObj:any = {}
        for(var labelIdx in this.mainRowArrayObj['labelsArray']){
          labelsObj[this.mainRowArrayObj['labelsArray'][labelIdx]['mainLabelName']] = parseInt(this.mainRowArrayObj['labelsArray'][labelIdx]['selectedName1'])
        }
        this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex'] = labelsObj;
        this.commonService.commonMainObj.bomProcessData['column_mapping'] = {
          "description": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['description'],
          "do_not_install": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['do_not_install'],
          "footprint": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['footprint'],
          "item_num": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['item_num'],
          "mpn": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['manufacturer_part_number'],
          "quantity": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['quantity'],
          "ref_designators": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['reference_designators'],
          "tolerance": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['tolerance'],
          "value": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['value'],
          "vendor": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['vendor'],
          "vpn": this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['vendor_part_number'],
          "manufacturer" : this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex']['manufacturer']
        },
        // this.commonService.commonMainObj.bomProcessData['column_mapping'] = this.commonService.commonMainObj.bomProcessXlData['columnheaderMapIndex'];
        this.commonService.commonMainObj.bomProcessData['bom_properties']['bom_name'] = this.commonService.commonMainObj.uploadedFileFullPath
        this.commonService.commonMainObj.bomProcessData['file']['filename'] = this.commonService.commonMainObj.uploadedFileFullPath
        this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['name'] = this.commonService.commonMainObj.uploadedFile.name
        this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'] = [];
        this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'].push(this.commonService.commonMainObj.bomProcessXlData['rowHeaderData']);
        var newArray = this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'].concat(this.commonService.commonMainObj.bomProcessXlData['dataRowsList'])
        this.commonService.commonMainObj.bomProcessData['file']['contents'][0]['data'] = newArray
        this.saveBOMFn(true);
        //to update dashboard
        let mindex=0;
        for(let cma of this.mainRowArrayObj['labelsArray']){
            if(cma.labelName == 'Footprint' || cma.labelName == 'Value' || cma.labelName == 'Description' || cma.labelName == 'vendor' || cma.labelName == 'tolerance' || cma.labelName == 'dni'|| cma.labelName == 'DNI' || cma.labelName == 'do_not_install' || cma.labelName == 'do not install' || cma.labelName == 'alt_mpn' || cma.labelName == 'alt_manufacturer_part_number1' || cma.labelName == 'alt_manufacturer_part_number'){
              mindex++;
              continue;
            }else if(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number'){
              this.mappingArray.push(cma.labelName);
              this.selectedColMapValList.push($('#columnMap_'+mindex).val())
              mindex++;
            }else if(!(cma.labelName =='Quantity' || cma.labelName =='Reference designator' || cma.labelName =='MPN' || cma.labelName =='Item Number')){
              this.mappingArray.push(cma.labelName);
              this.selectedColMapValList.push($('#columnMap_'+mindex).val())
              mindex++;
            }
            
        }

        for(let i=0; i<this.selectedColMapValList.length;i++){
          for(let crow of this.mainRowArrayObj['bomOneMapArrayData']){
          
            if(this.selectedColMapValList[i] == crow.selectedObj){
              this.mapValueArray.push(crow.labelValue);
            }
          }
        }
        console.log("mappingArray",this.mappingArray);
        console.log("selectedColMapValList",this.selectedColMapValList)
        console.log("this.mapValueArray",this.mapValueArray)
        this.bomMappingKeyObj = Object.fromEntries(this.mappingArray.map((key:any, index:any) => [key, this.mapValueArray[index]]));
        var bomColMappingObj ={
          "mapping":this.bomMappingKeyObj
        }
        this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
        this.apiService.updateDetailsToDashboard(this.flowActivityId,bomColMappingObj,'BOMColumnPage').subscribe((resDatas)=>{
        },err=>{
          console.log(err)
          });

        this.modalService.dismissAll('Save click');
      },1000);
    }
  }

  autoMapModal(content:any){
    this.commonService.loadingHide();
    this.commonService.formattingCurrentDateTime();
    this.flowActivityId = this.commonService.commonMainObj.backToPrevPageActivityId != '' ? this.commonService.commonMainObj.backToPrevPageActivityId:this.commonService.commonMainObj.fileId;
    var bomAutoMapObj={
      "pageVisited":"Date:  "+this.commonService.commonMainObj.formattedDate+" " +"Time:"+this.commonService.commonMainObj.formattedTime
    }
    this.apiService.updateDetailsToDashboard(this.flowActivityId,bomAutoMapObj,'BOMColumnPage').subscribe((resDatas)=>{
    },err=>{
      console.log(err)
      });
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      console.log(reason);
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }


  getBOMTableData(param:any){
    this.commonService.loadingShow();
    this.sqsgenerationcount = 0.0;
    // var data:any = {};
    // data = this.commonService.commonMainObj.bomProcessItemsData;
    this.apiService.getBOMTable(this.commonService.commonMainObj.bomProcessXlData.bom_id).subscribe((data) =>{
      this.buttonsDisabled = true;
      this.commonService.commonMainObj.bomFileLineItemData = data;
      if(data.bom_items){
        // if(param == 'pregenerated'){
        //   sessionStorage.setItem('pre_generate_bomId','');
        //   sessionStorage.setItem('pre_generate_bomId',this.commonService.commonMainObj.bomProcessXlData.bom_id);
        // }
        this.bomDataItems['lineItems'] = [];
        this.processFlowObj = {preLoading: false, bomTable: true, bomCustomUpload: false, bomColumnScreen: false,pregeneratedLength: '', customLength: '',customBomUploadMsg: false,bomTableMsg: true};
        this.bomDataItems['lineItems'] = data.bom_items;
        this.commonService.commonMainObj.uploadedBomDataItems = this.bomDataItems['lineItems'];
        //console.log("BOMDATA", data);
        // localStorage.setItem('bomId',data.bom_id);
        // localStorage.setItem('userId',data.user_id);
        // localStorage.setItem('projectId',data.project_id);
        // localStorage.setItem('assemblyPartNumber', data.bom_properties.assemblyPartNumber);
        this.bomId = data.bom_id;
        this.lostBomItemIndex = data.bom_items.length + 1;
        for(var itmIndx in this.bomDataItems['lineItems']){
          this.bomDataItems['lineItems'][itmIndx]['statusAray'] = []
          if(this.bomDataItems['lineItems'][itmIndx].status != 'Valid'){
            for(var indx in this.bomDataItems['lineItems'][itmIndx].status){
              this.bomDataItems['lineItems'][itmIndx]['statusAray'].push(this.bomDataItems['lineItems'][itmIndx].status[indx].split('Invalid - ')[1]);
            }
            // this.bomDataItems['lineItems'][itmIndx]['statusAray'] = this.bomDataItems['lineItems'][itmIndx].status[0].split('Invalid - ')
          }
          // this.bomDataItems['lineItems'][itmIndx]['imported']['item_num'] = (parseInt(itmIndx)+1)+'';
          if (this.bomDataItems['lineItems'][itmIndx]['selected_part'] && !this.bomDataItems['lineItems'][itmIndx]['imported']['mpn']) {
            this.bomDataItems['lineItems'][itmIndx]['imported']['mpn'] = this.bomDataItems['lineItems'][itmIndx]['selected_part']['mpn'];
          }
          if(this.bomDataItems['lineItems'][itmIndx]['selected_part'] && !this.bomDataItems['lineItems'][itmIndx]['imported']['manufacturer']){
            this.bomDataItems['lineItems'][itmIndx]['imported']['manufacturer'] = (this.bomDataItems['lineItems'][itmIndx]['selected_part']['manufacturer']?this.bomDataItems['lineItems'][itmIndx]['selected_part']['manufacturer']['name']:'');
          }
          if((this.bomDataItems['lineItems'][itmIndx].status[0].indexOf('Invalid')>=0 || this.bomDataItems['lineItems'][itmIndx].status.indexOf('Invalid')>=0) ){
            this.bomDataItems['lineItems'][itmIndx]['selected_part'] = null
          }
          // if (this.bomDataItems['lineItems'][itmIndx]['imported']['do_not_install'] == 'DNI') {
          //   this.bomDataItems['lineItems'][itmIndx]['imported']['manufacturer'] = '';
          // }
        }
        setTimeout(()=>{
          this.checkingErrorsCount(data.bom_items.length,param);
          this.dniCheckFn();
        },500)
      }else{
        this.bomDataItems['lineItems'] = [];
        this.commonService.commonMainObj.initialPrecheck = true;
        // this.processFlowObj = {preLoading: false, bomTable: true, bomCustomUpload: false, bomColumnScreen: false,pregeneratedLength: '', customLength: '',customBomUploadMsg: false,bomTableMsg: true};
      }
      this.itemsLength = data.bom_items.length;
      setTimeout(() => {
        this.commonService.loadingHide();
      }, data.bom_items.length<=100? 1000 :data.bom_items.length<=200? 3000 : data.bom_items.length<=500 ? 5000 : data.bom_items.length<=1100 ? 7000 : 500);
    }, error =>{
      console.log('error found while getting bom data', error);
      this.bomDataItems['lineItems'] = [];
      if (param == 'upload') {
        this.processFlowObj = {preLoading: false, bomTable: true, bomCustomUpload: false, bomColumnScreen: false,pregeneratedLength: '', customLength: '',customBomUploadMsg: true,bomTableMsg: false};
      }else{
        this.processFlowObj = {preLoading: false, bomTable: true, bomCustomUpload: false, bomColumnScreen: false,pregeneratedLength: '', customLength: '',customBomUploadMsg: false,bomTableMsg: true};
      }
    })
  }

  
  dniCheckFn(){
    this.countDniCheck = 0;
    for(var itmIndx in this.bomDataItems['lineItems']){
      if(this.bomDataItems['lineItems'][itmIndx]['imported']['do_not_install'] == 'DNI'){
        this.countDniCheck++;
      }
    }
    if( this.countDniCheck != 0 && this.countDniCheck == this.bomDataItems['lineItems'].length){
      this.commonService.alertCall('Alert!',"If you don't want to assemble boards, please proceed with the PCB checkout.");
    }
  }

  // showPartWebview(type:any, title:any, url:any){
  //   FileSaver.saveAs(url, title);
  // }

  // async fixLineItem(fixObjData:any){
  //   console.log(fixObjData);
  //   this.bomDataItems['selectedBOMFile'] = fixObjData;
  //   const fixLineItemModal = await this.modelController.create({
  //       component:BomSearchAssistPage,
  //       componentProps: {'fixObjData':fixObjData},
  //       backdropDismiss: false,
  //       cssClass: 'search-assist-class'
  //   });
  //   fixLineItemModal.onDidDismiss().then((modalElementFixObj)=>{
  //     if(modalElementFixObj.data){
  //       this.remoteService.showLoader();
  //         var sendData = Object.assign({},fixObjData)
  //       sendData.imported.mpn = modalElementFixObj.data.mpn
  //       sendData.imported.vpn = modalElementFixObj.data.vpn
  //       sendData.imported.vendor = modalElementFixObj.data.vendor.name
  //       sendData.imported.footprint = modalElementFixObj.data.size_footprint
  //       sendData.imported.status = modalElementFixObj.data.rohs.status
  //       sendData.imported.manufacturer = modalElementFixObj.data.manufacturer.name
  //       sendData.imported.description = modalElementFixObj.data.brief_description
  //       sendData.imported.value = modalElementFixObj.data.value ? modalElementFixObj.data.value : ''
  //       // sendData.imported.ref_designators = modalElementFixObj.exact_part.ref_designators ? modalElementFixObj.exact_part.ref_designators : ''
  //       sendData.imported.exact_part = modalElementFixObj.data
  //       sendData.quantity = modalElementFixObj.data.quantity ? modalElementFixObj.data.quantity : ''
  //       console.log(JSON.stringify(sendData))
  //         this.selectedSearchBOM = sendData;
  //       this.remoteService.saveEditOrFixLineItemReq(sendData).subscribe((data: any)=>{
  //         // alert('BOM Item Fixed successfully')
  //         this.sqsgenerationcount = 0.0;
  //         this.checkingErrorsCount(this.bomDataItems['lineItems'].length,'search'); 
  //       },err=>{
  //         this.remoteService.hideLoader();
  //         console.log(err)
  //       });
  //     }
  //   })

  //   return await fixLineItemModal.present();
  // }

  
  saveLineItemEdit(){
    this.commonService.loadingShow();
    var saveLineItemData:any = {};
    saveLineItemData['imported'] = {}
    saveLineItemData['bom_id'] = this.bomId
    saveLineItemData['bom_item_id'] = this.selectedBomObj.bom_item_id
    saveLineItemData['imported']['item_num'] = this.editLineItemForm.controls.item_num.value
    saveLineItemData['imported']['quantity'] = (this.editLineItemForm.controls.quantity.value?this.editLineItemForm.controls.quantity.value:undefined)
    saveLineItemData['imported']['mpn'] = (this.editLineItemForm.controls.mpn.value?this.editLineItemForm.controls.mpn.value:undefined)
    saveLineItemData['imported']['ref_designators'] = (this.editLineItemForm.controls.ref_designators.value?this.editLineItemForm.controls.ref_designators.value:undefined)
    saveLineItemData['imported']['manufacturer'] = (this.editLineItemForm.controls.manufacturer.value?this.editLineItemForm.controls.manufacturer.value:undefined)
    saveLineItemData['imported']['vpn'] = (this.editLineItemForm.controls.vpn.value?this.editLineItemForm.controls.vpn.value:undefined)
    saveLineItemData['imported']['vendor'] = (this.editLineItemForm.controls.vendor.value?this.editLineItemForm.controls.vendor.value:undefined)
    saveLineItemData['imported']['description'] = (this.editLineItemForm.controls.description.value?this.editLineItemForm.controls.description.value:undefined)
    saveLineItemData['imported']['do_not_install'] = (this.editLineItemForm.controls.do_not_install.value?this.editLineItemForm.controls.do_not_install.value == true?'DNI':'':'')
    saveLineItemData['imported']['value'] = (this.editLineItemForm.controls.value.value?this.editLineItemForm.controls.value.value:undefined)
    saveLineItemData['imported']['footprint'] = (this.editLineItemForm.controls.footprint.value?this.editLineItemForm.controls.footprint.value:undefined)
    saveLineItemData['imported']['exact_part'] = null
    this.apiService.saveEditOrFixLineItemReq(saveLineItemData).subscribe((data: any)=>{
      // alert('BOM Item edited successfully') 
        setTimeout(() => {
          var getType = (this.processFlowObj.customBomUploadMsg?'upload':'pregenerated');
          this.getBOMTableData(getType);
          this.closeLineItemEdit();
          this.commonService.loadingShow();
          console.log("itemsLength",this.itemsLength)
          // this.sqsgenerationcount = 0.0;
          // this.checkingErrorsCount(this.bomDataItems['lineItems'].length,'edit');
        },1500);
        setTimeout(() => {
          this.commonService.loadingHide();
        }, this.itemsLength<=100? 1000 :this.itemsLength<=200? 3000 : this.itemsLength<=500 ? 5000 : this.itemsLength<=1100 ? 7000 : 1500);
    },err=>{
      this.commonService.loadingHide();
      // this.remoteService.hideLoader();
      console.log(err)
    });
  }

  closeLineItemEdit(){
    this.commonService.loadingHide();
    this.showLineItemEdit = false;
    $('.table-row').css('overflow-y', 'auto');
    $('.table-row').css('height', '400px');
    this.selectedBomObj = "";
    $('.table-bar').css('margin-top', '0px');
  }

  async deleteOrUpdateLineItem(clickType:any){
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{      
          if(data.status == 1){
            this.callDeleteLineItemLogic(clickType); 
          }else{
            this.commonService.alertCall('Alert!!','Session expired!!'); 
            this.commonService.goBack();      
          }     
        },error =>{
          console.log('Error in checking user session', error);     
        })
      },800);
    }else{  
      this.callDeleteLineItemLogic(clickType); 
    }
    
  }

  callDeleteLineItemLogic(clickType:any){
    var selectedItems = 0;
    if(this.bomDataItems['lineItems'].length>0){
      for(var itemIndx in this.bomDataItems['lineItems']){
        if(this.bomDataItems['lineItems'][itemIndx].checkedModel){
          selectedItems++;
        }
      }
    }
    if(selectedItems == 0){
      // var msgAlert = clickType == 'delete'? 'to delete':'to update'
      this.commonService.alertCall('Alert!',"please select line items to "+ clickType +".");
      // this.buttonsDisabled = true;
      return false;
    }
    if(selectedItems > 40){
      this.commonService.alertCall('Alert!',"Please select a maximum of 40 line items at a time.");
      this.buttonsDisabled = true;
      return false;
    }
    if (this.showLineItemEdit) {
      this.closeLineItemEdit();
    }
    if(clickType == 'delete'){
      this.deleteLineItem();
    }else{
      this.UpdateLineItems();
    }
    // var alertMsg = (clickType == 'delete'?'Are you sure, you want to delete the selected BOM line items?':'Are you sure, you want to update the selected BOM line items as DNI?')
    // const alert = await this.alertController.create({
    //   cssClass: 'my-custom-class',
    //   subHeader: alertMsg,
    //   backdropDismiss: false,
    //   buttons: [
    //     {
    //       text: 'Ok',
    //       cssClass: 'secondary',
    //       handler: () => {
    //         console.log('Confirm Delete');
    //         if(clickType == 'delete'){
    //           this.deleteLineItem();
    //         }else{
    //           this.UpdateLineItems();
    //         }
    //       }
    //     },
    //     {
    //       text: 'Cancel',
    //       role: 'cancel',
    //       cssClass: 'danger delete-address',
    //       handler: (blah) => {
    //         console.log('Confirm Cancel: blah');
    //       }
    //     }
    //   ]
    // });

    // await alert.present();
  }

  // async addNewLineItem(ItemNumber:any,bomId:any){
  //   console.log(this.lostBomItemIndex);
  //   if (this.showLineItemEdit) {
  //     this.closeLineItemEdit();
  //   }
  //   let newLineItemObj:any = {}
  //   newLineItemObj["imported"] = {
  //     "item_num":ItemNumber,"qty_needed":'1000',"ref_designators":"","value":"","footprint":"","tolerance":"","voltage":"","current":'',"power":'','lineItem':"newLineItem",'bom_id':bomId
  //   }
  //   const newLineItemModel = await this.modelController.create({
  //     component:BomSearchAssistPage,
  //     componentProps: {'fixObjData':newLineItemObj},
  //     backdropDismiss: false,
  //     cssClass: 'search-assist-class'
  //   });

  //   newLineItemModel.onDidDismiss().then((modalresponcedata)=>{
  //     if(modalresponcedata.data){
  //       setTimeout(()=>{
  //         var getType = (this.processFlowObj.customBomUploadMsg?'upload':'pregenerated');
  //         this.getBOMTableData(getType);
  //       },500)
  //     }
  //   });
  //   return await newLineItemModel.present();
  // }

  routeCustomUpload(){
    if (this.showLineItemEdit) {
      this.closeLineItemEdit();
    }
    this.headerCheck = false;
    this.processFlowObj = {preLoading: false, bomTable: false, bomCustomUpload: true, bomColumnScreen: false,pregeneratedLength: '', customLength: '',customBomUploadMsg: false,bomTableMsg: false};
  }

  
  checkingErrorsCount(count:any,param:any){
    this.errorsCountReChecking();
        if (param == 'pregenerated') {
          this.processFlowObj.pregeneratedLength = this.bomDataItems['lineItems'].length;
        }

        if (param == 'upload') {
          this.processFlowObj.customLength = this.bomDataItems['lineItems'].length;
        }

        if (localStorage.getItem('customBomUpload')=='true') {
          this.commonService.commonMainObj.initialPrecheck = true;
          this.processFlowObj.customBomUploadMsg = true;
          this.processFlowObj.bomTableMsg = false;
        }
  }

  errorsCountReChecking(){
    this.bomDataItems['count'] = {};
    this.bomDataItems['count']['errorCount'] = 0;
    this.bomDataItems['count']['validatingErrorCount'] = 0;
    this.bomDataItems['count']['successCount'] = 0;
    for(var bomcheck in this.bomDataItems['lineItems']){
        if (this.bomDataItems['lineItems'][bomcheck].status) {
          if ((this.bomDataItems['lineItems'][bomcheck]['imported']['do_not_install'] != null || this.bomDataItems['lineItems'][bomcheck]['imported']['do_not_install'] != '') && (this.bomDataItems['lineItems'][bomcheck].status[0].indexOf('Invalid')>=0 || this.bomDataItems['lineItems'][bomcheck].status[0].indexOf('Validating')>=0) || (this.bomDataItems['lineItems'][bomcheck].status.indexOf('Invalid')>=0 || this.bomDataItems['lineItems'][bomcheck].status.indexOf('Validating')>=0)) {
            this.bomDataItems['count']['errorCount'] = this.bomDataItems['count']['errorCount']+1;
            if (this.bomDataItems['lineItems'][bomcheck].status[0].indexOf('Validating')>=0 || this.bomDataItems['lineItems'][bomcheck].status.indexOf('Validating')>=0) {
              this.bomDataItems['count']['validatingErrorCount'] = this.bomDataItems['count']['validatingErrorCount']+1
            }
          }else{
            this.bomDataItems['count']['successCount'] = this.bomDataItems['count']['successCount']+1;
          }
        }
        // else{
        //   this.bomDataItems['count']['errorCount'] = this.bomDataItems['count']['errorCount']+1;
        // }
      
      }
  }
  
  deleteLineItem(){
    // this.remoteService.showLoader();
    var newArray:any = []
    this.bomDataItems['lineItems'].map(function(elem:any){
      if(elem.checkedModel){
        newArray.push(elem.bom_item_id)
        // return elem.bom_item_id;
      }
    })
    let keys = newArray.join(",")
    this.headerCheck = false;
    this.buttonsDisabled = true;
    this.apiService.deleteLineItemData(this.bomDataItems['lineItems'][0].bom_id,keys).subscribe((resData: any)=>{
      // var getType = (this.processFlowObj.customBomUploadMsg?'upload':'pregenerated');
      this.showNoDataMsg = (newArray.length == this.bomDataItems['lineItems'].length?"Please upload a BOM.":this.showNoDataMsg);
      this.getBOMTableData('delete');
      setTimeout(() =>{
        // this.remoteService.hideLoader();
      },2000);
    })
  }

  
  UpdateLineItems(){
    this.headerCheck = false;
    let updateItemsCount = 0;
    let updateResItemsCount = 0;
    this.buttonsDisabled = true;
    
    var newArray:any = []
    var multiCheckCount = 0;
    this.bomDataItems['lineItems'].map(function(elem:any){
      if(elem.checkedModel){
        multiCheckCount++
        newArray.push(elem.bom_item_id)
        // return elem.bom_item_id;
      }
    })
    if(multiCheckCount > 1){
      let keys = newArray.join(",");
      this.commonService.loadingShow();
      this.apiService.saveEditDni(keys,this.bomId).subscribe((data: any)=>{
        this.commonService.loadingHide();
        var getType = (this.processFlowObj.customBomUploadMsg?'upload':'pregenerated');
        this.getBOMTableData(getType)
      })
    }else{
      for(var itemIndx in this.bomDataItems['lineItems']){
        if(this.bomDataItems['lineItems'][itemIndx].checkedModel){
          updateItemsCount++;
          var updateLineItemData =JSON.parse(JSON.stringify(this.bomDataItems['lineItems'][itemIndx]));
          updateLineItemData['imported']['do_not_install'] = 'DNI';
          delete updateLineItemData.checkedModel
          this.commonService.loadingShow();
          this.apiService.saveEditOrFixLineItemReq(updateLineItemData).subscribe((data: any)=>{
            this.commonService.loadingHide();
            updateResItemsCount++;
            if(updateItemsCount === updateResItemsCount){
              var getType = (this.processFlowObj.customBomUploadMsg?'upload':'pregenerated');
              this.getBOMTableData(getType)
            }
              // this.sqsgenerationcount = 0.0;
              // this.checkingErrorsCount(this.bomDataItems['lineItems'].length,'upload');
          },err=>{
            this.commonService.loadingHide();
            console.log(err)
          });
        }
      }
    }
  }


  lineItemUpdate(typeEdit:any){
    this.showSaveItemEditOpt = typeEdit == 'true'? true : false;
  }

  checkedLineItem(selectType:any){
    setTimeout(()=>{
      if(selectType == 'all'){
        if(this.headerCheck){
          for(var itemIndx in this.bomDataItems['lineItems']){
            // if(parseFloat(itemIndx) < 40){
              this.bomDataItems['lineItems'][itemIndx].checkedModel = true;
              this.buttonsDisabled = false;
            // }else{
            //   this.remoteService.alertCall('Alert!',"Please select a maximum of 40 line items at a time.");
            //   break;
            // }
          }
        }else{
          for(var itemIndx in this.bomDataItems['lineItems']){
            this.bomDataItems['lineItems'][itemIndx].checkedModel = false;
            this.buttonsDisabled = true;
          }
        }
      }else{
        for(var itemIndx in this.bomDataItems['lineItems']){

          if(this.headerCheck){
            this.headerCheck = false;
          }
          
          if(this.bomDataItems['lineItems'][itemIndx].checkedModel){
            this.buttonsDisabled = false;
            break;
          }else{
            this.buttonsDisabled = true;
          }

        }
      }
    },200);
  }

  showLineItemView(data:any,event:any){
    if(data.status != 'Invalid - part not found!!'){
      this.selectedBomObj = Object.assign({}, data);
      this.bomDataItems['selectedBOMFile'] = data;
      if(!this.selectedBomObj['selected_part']){ 
        this.selectedBomObj['selected_part'] = {};
        this.selectedBomObj['selected_part']['manufacturer'] = {};
      }
      var table = $('.table-row');
      var row = table.find('table tbody tr'); 
      var elId:any = document.getElementById('bom-table-id')
      elId.scrollTo({top: row[event].offsetTop - 45, behavior: 'smooth'});
      $('.table-row').css('overflow-y', 'hidden');
      // if(window.screen.availHeight >= 900 && window.screen.availWidth >= 1600){
      $('.table-row').css('height', $('.table_header')[0].offsetHeight + 'px');
      // }else{
      //   $('.table-row').css('height', '50px');
      // }
      this.showLineItemEdit = true;
      setTimeout(()=>{
        $('.line-item-edit').css('top', (table.find('table thead')[0].style.height +35)+'px');
          var docQuerySel:any = document.querySelector('.line-item-edit')
          docQuerySel.scrollTo({top: (table.find('table thead')[0].style.height +36), behavior: 'smooth'});
        // setTimeout(()=>{
          $('.table-bar').css('margin-top', (row[event].offsetHeight -55)+'px');
        // },200);
        // value search form
        this.editLineItemForm = new FormGroup({
          item_num:new FormControl(this.selectedBomObj.imported['item_num']?this.selectedBomObj.imported['item_num']:'', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
          mpn: new FormControl(this.selectedBomObj.imported['mpn']?this.selectedBomObj.imported['mpn']:'', [Validators.required, Validators.minLength(1)]),
          value: new FormControl(this.selectedBomObj.imported['value'], []),
          quantity: new FormControl(this.selectedBomObj.imported['quantity']?this.selectedBomObj.imported['quantity']:'', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
          manufacturer: new FormControl(this.selectedBomObj.imported['manufacturer']?this.selectedBomObj.imported['manufacturer']:'', []),
          footprint: new FormControl(this.selectedBomObj.imported['footprint']?this.selectedBomObj.imported['footprint']:'', []),
          // commenting as per KIP-1276 to remove the max length validation for ref_designators 
          // ref_designators: new FormControl(this.selectedBomObj.imported['ref_designators']?this.selectedBomObj.imported['ref_designators']:'', [Validators.required, Validators.minLength(1), Validators.maxLength(100)]),
          ref_designators: new FormControl(this.selectedBomObj.imported['ref_designators']?this.selectedBomObj.imported['ref_designators']:'', [Validators.required, Validators.minLength(1)]),
          vpn: new FormControl(this.selectedBomObj.imported['vpn']?this.selectedBomObj.imported['vpn']:'', []),
          description: new FormControl(this.selectedBomObj.imported['description']?this.selectedBomObj.imported['description']:'', []),
          vendor: new FormControl(this.selectedBomObj.imported['vendor']?this.selectedBomObj.imported['vendor']:'', []),
          do_not_install: new FormControl(this.selectedBomObj.imported['do_not_install']?true:false, [])
        });
        // $('.line-item-edit').css('top', (row[event].clientHeight + table.find('table thead')[0].clientHeight)+'px');
      },50);
    }
  }

  checkStatus(status:any){
    if (status) {
      //  || (status.indexOf('Duplicate')>=0)
      if (status == 'Invalid - part not found!!') {
        return true
      }else{
        return false
      }
    }
  }
  
  bomProcessContinue(){
    this.commonService.sessionPortalLoad();
    if(this.bomDataItems['lineItems'].length == 0 || this.bomDataItems['count'].errorCount>0 || this.countDniCheck == this.bomDataItems['lineItems'].length){
      this.commonService.showtoast('Please fix all BOM issues to continue','warning');
      return false;
    }
    var errormsg = '';
    for(var bomcheck in this.bomDataItems['lineItems']){
      if(!this.bomDataItems['lineItems'][bomcheck]['imported'].quantity && this.bomDataItems['lineItems'][bomcheck]['imported']['do_not_install'] != 'DNI'){
        errormsg = 'Qty is missing in line item no '+ this.bomDataItems['lineItems'][bomcheck]['imported'].item_num
        break;
      }
      if(!this.bomDataItems['lineItems'][bomcheck]['imported'].ref_designators && this.bomDataItems['lineItems'][bomcheck]['imported']['do_not_install'] != 'DNI'){
        errormsg = 'Reference Designators is missing in line item no '+ this.bomDataItems['lineItems'][bomcheck]['imported'].item_num
        break;
      }
      if(!this.bomDataItems['lineItems'][bomcheck]['imported'].mpn){
        errormsg = 'MPN is missing in line item no '+ this.bomDataItems['lineItems'][bomcheck]['imported'].item_num
        break;
      }
    }
    if(errormsg){
      this.commonService.alertCall("Alert!", errormsg);
      return false;
    }
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
      setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            if(this.commonService.commonMainObj.customAssemblySelected == true && this.commonService.commonMainObj.pcbType == "Custom/Advanced PCB"){
              this.bomProcessContinueToCustomCpp();
            }else{
              this.bomProcessContinueSessionChecked();
            }
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      },800);
    }else{
      if(this.commonService.commonMainObj.customAssemblySelected == true && this.commonService.commonMainObj.pcbType == "Custom/Advanced PCB"){
        this.bomProcessContinueToCustomCpp();
      }else{
        this.bomProcessContinueSessionChecked();
      }
    }
  }

  bomProcessContinueSessionChecked(){
    this.commonService.sessionPortalLoad();
    this.commonService.commonMainObj.numItemsCharging = 0;
    if (this.bomDataItems['count']['errorCount'] == 0) {
      var finalBomData:any = {
        "bom_id" : this.bomDataItems['lineItems'][0].bom_id,
        "fileName" : this.commonService.commonMainObj.uploadedFile.name
      }
      finalBomData['bom_items'] = []
      for(var bomcheck in this.bomDataItems['lineItems']){
        // if(this.bomDataItems['lineItems'][bomcheck].selected_part == null){
        //   this.bomDataItems['lineItems'][bomcheck].selected_part = {};
        //   this.bomDataItems['lineItems'][bomcheck].selected_part['mpn'] = this.bomDataItems['lineItems'][bomcheck].mpn? this.bomDataItems['lineItems'][bomcheck].mpn : null;
        // }

        var sjghs = this.bomDataItems['lineItems'][bomcheck]['imported'];
        for(var sjghsIndx in sjghs){
          if(sjghs[sjghsIndx] == null){
            sjghs[sjghsIndx] = '';
          }
        }
        finalBomData['bom_items'].push(sjghs);
      }
      //console.log("FINAL DATA", finalBomData);
      const keysToRemove = ['alt_vpn', 'alt_vendor', 'tolerance', 'exact_part'];
      finalBomData.bom_items = finalBomData.bom_items.map((item: { [x: string]: any; }) => {
        keysToRemove.forEach(key => delete item[key]);
        return item;
      })
      this.commonService.loadingShow();
      // OFP-1033
      // console.log("this.commonService.commonMainObj.bomFileLineItemData.bom_items 123",this.commonService.commonMainObj.bomFileLineItemData.bom_items);
      // console.log("this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data 123",this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data);
      for(var i in this.commonService.commonMainObj.bomFileLineItemData.bom_items){
        for(var j in this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data){
          if(this.commonService.commonMainObj.bomFileLineItemData.bom_items[i].item_num == this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data[j][0]){
            this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data[j][this.commonService.commonMainObj.qtyIndex] = this.commonService.commonMainObj.bomFileLineItemData.bom_items[i].quantity;
            this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data[j][this.commonService.commonMainObj.mpnIndex] = this.commonService.commonMainObj.bomFileLineItemData.bom_items[i].imported.mpn;
            this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data[j][this.commonService.commonMainObj.refDesignatorIndex] = this.commonService.commonMainObj.bomFileLineItemData.bom_items[i].imported.ref_designators;
            this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data[j][this.commonService.commonMainObj.partNumberIndex] = this.commonService.commonMainObj.bomFileLineItemData.bom_items[i].imported.vpn;
            this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data[j][this.commonService.commonMainObj.maufacturerIndex] = this.commonService.commonMainObj.bomFileLineItemData.bom_items[i].imported.manufacturer;
            this.fixedLineItemsArray.push(this.commonService.commonMainObj.bomFileLineItemData.file.contents[0].data[j]);
          }
        }
      }
      var objData = {
        "header": this.commonService.commonMainObj.autoMappingHeaderData,
        "content" : this.fixedLineItemsArray
      }
      var formBOMQuoteData = new FormData();
      formBOMQuoteData.append('s3ZipFileName', this.commonService.commonMainObj.s3FileName);
      formBOMQuoteData.append('excelData', JSON.stringify(objData));
      setTimeout(() => {
        this.sendBomDataToAttach(formBOMQuoteData);
      }, 2000);
      //Changes related to OFP-1033 End////////////////////////////
      this.apiService.bomQuoteData(finalBomData).subscribe((finBomRes: any)=>{
        if(this.commonService.commonMainObj.userSessionMemberId != null){
          this.commonService.sessionPortalLoad();
          setTimeout(()=>{
            this.commonService.loadingHide();
            this.apiService.checkUserSessionApi().subscribe((data: any)=>{
              if(data.status == 1){
                this.commonService.loadingHide();
                this.commonService.commonMainObj.numItemsCharging = this.bomDataItems['count'].successCount - this.countDniCheck;
                  // this.commonService.commonMainObj.finalBomDataPrices = finBomRes[0];
                  this.commonService.commonMainObj.finalBomDataToPurchase = finBomRes
                  // this.pageShow = {
                  //   "showLevel1BomItemsData" : false,
                  //   "showerrorFreeBomItemsData" : true
                  // }
                  this.router.navigateByUrl('/componentProcurement');
              }
            },error =>{
              console.log('Error in checking user session', error);   
            })
          },500);
        }else{
          this.commonService.loadingHide();
          this.commonService.commonMainObj.numItemsCharging = this.bomDataItems['count'].successCount - this.countDniCheck;
            // this.commonService.commonMainObj.finalBomDataPrices = finBomRes[0];
            this.commonService.commonMainObj.finalBomDataToPurchase = finBomRes
            // this.pageShow = {
            //   "showLevel1BomItemsData" : false,
            //   "showerrorFreeBomItemsData" : true
            // }
            this.router.navigateByUrl('/componentProcurement');
        }
      },err=>{
        this.commonService.loadingHide();
        console.log(err)
      });
    }
  }

  bomProcessContinueToCustomCpp(){
    //call bom pricing API
    var finalBomLineItems = [];
    this.commonService.commonMainObj.bomLineItemsSavedForCustomCpp = this.bomDataItems['lineItems'];
    for(var bomcheck in this.bomDataItems['lineItems']){
      var lineItems={
        'itemNo': this.bomDataItems['lineItems'][bomcheck]['imported'].item_num?this.bomDataItems['lineItems'][bomcheck]['imported'].item_num:'',
        'manufacturer':this.bomDataItems['lineItems'][bomcheck]['imported'].manufacturer,
        'mpn':this.bomDataItems['lineItems'][bomcheck]['imported'].mpn,
        'qtyperBoard':this.bomDataItems['lineItems'][bomcheck]['imported'].quantity,
        'refDes':this.bomDataItems['lineItems'][bomcheck]['imported'].ref_designators,
        'dni':this.bomDataItems['lineItems'][bomcheck]['imported'].do_not_install == null ? "": this.bomDataItems['lineItems'][bomcheck]['imported'].do_not_install
      }
      finalBomLineItems.push(lineItems);
    }
    var finalCustomBomData:any = {
      "boardQuantity" :[this.commonService.commonMainObj.customQtyOfAssemblies] ,
      "items": finalBomLineItems
    }
    this.commonService.loadingShow();
    this.apiService.requestForCustomBomPricing(finalCustomBomData).subscribe((result:any) =>{
      this.commonService.loadingHide();
      this.commonService.commonMainObj.customBomPricingData = result;
      this.router.navigateByUrl('/customQuoteComponentProcurement');
    },err=>{
      this.commonService.loadingHide();
        console.log(err)
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  attachUploadedBomToZip(){
    var objData = {
      "file1":{
        "file": this.commonService.commonMainObj.bomToBloobFile,
        "fileName":this.commonService.commonMainObj.uploadedFile.name,
        "errorCode":"FV_BM_E00"
      }
    }
    var dataFile = JSON.stringify(objData);
    var formData = new FormData();
    formData.append('data',dataFile);
    formData.append('s3ZipFileName', this.commonService.commonMainObj.s3FileName);
    formData.append('reValidate', "True");
    console.log("formdata",formData );
    this.apiService.reValidateMissingFiles(formData).subscribe((data: any)=>{
      this.commonService.commonMainObj.s3FileName = data.s3_file;
      if(Object.keys(data['assemblyErrors']).length == 0){
        console.log("No error found");
      }
      if(Object.keys(data['assemblyErrors']).length > 0){
        console.log("error found");
      }
      console.log(data);
    });
  }

  sendBomDataToAttach(bomData:any){
    this.apiService.generateQuoteBOM(bomData).subscribe((data) =>{
      if (data.success) {
        // console.log("DATA SUCCESS", data);
      }
    }, error =>{
      console.log('Bom file saving Error', error);
    })
  }
}
